



















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { mdiHome, mdiDotsHorizontal } from "@mdi/js";

@Component
export default class StatCard extends Vue {
  @Prop({ default: "Total Patients" }) title!: string;
  @Prop({ default: 500 }) value!: number;
  @Prop({ default: mdiHome }) icon!: string;
  @Prop({ default: "#5d1acf" }) iconColor!: string;

  dotIcon: string = mdiDotsHorizontal;
  iconBkgColor: string = this.iconColor;

  created() {
    if (this.iconColor && this.iconColor.startsWith("rgba")) {
      const regex = /\s*\d{0,10}(\.\d{0,10})?\)/;
      this.iconBkgColor = this.iconBkgColor.replace(regex, " 0.2)");
    }
  }
}
